import {useState, useEffect, useCallback} from 'react';

export const useStripeCustomer = (customerId) => {
  const [customer, setCustomer] = useState({});
  const [hasLoaded, setHasLoaded] = useState(false);

  const getCustomer = useCallback(() => {
    setHasLoaded(false);
    if(customerId) {
      fetch(`/api/stripe/customer/${customerId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(async res => {
        if(!res.ok) {
          throw('Something went wrong retrieving the customer');
        }
        const cust = await res.json();
        setCustomer(cust);
      }).finally(() => {
        setHasLoaded(true);
      })
    } else {
      setHasLoaded(true);
    }
  }, [customerId]);

  useEffect(() => {
    getCustomer();
  }, [getCustomer]);

  return [hasLoaded ? customer : null, getCustomer];
}
